import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ApiService } from "src/app/services";

@Component({
  standalone: false,
  templateUrl: "./resource-approvers-modal.component.html",
  styleUrls: ["../../styles.scss"],
})
export class ResourceApproversModalComponent implements OnInit {
  @Input() approvalType: string;
  @Input() region: string;

  approvers$: Observable<string[]> = of([]);
  message = "";

  constructor(
    public activeModal: NgbActiveModal,
    protected apiService: ApiService,
    protected notificationService: ToastrService) { }

  ngOnInit() {
    if (this.approvalType && this.region) {
      this.approvers$ = this.apiService.getApproversByTypeAndRegion(this.approvalType, this.region).pipe(
        map((res) => res ?? []),
        catchError((err) => {
          this.message = err?.message;
          this.notificationService.error(this.message);
          return of([]);
        })
      );
    }
  }
}
